import { CustomerStoriesSection } from '@/components/web/home/customer-stories-section';
import { DestinationsSection } from '@/components/web/home/destinations-section';
import { FeaturedVouchersSection } from '@/components/web/home/featured-vouchers';
import { HeroSearchSection } from '@/components/web/home/hero-search-section';
import { NewsMasonrySection } from '@/components/web/home/news-masonry-section';
import { NewsletterSection } from '@/components/web/home/newsletter-section';
import { TrustStrip } from '@/components/web/home/trust-strip';
import WebLayout from '@/components/web/layouts/web-layout';
import { type HomePageData } from '@/types/search';
import { Head } from '@inertiajs/react';

interface HomeProps extends HomePageData {}

/**
 * Ecosystem Index: a search-first hero over a stack of discovery rails.
 *
 * Section rhythm lives on the wrapper's `space-y-*`, not on each section — the rails
 * carry no padding of their own. Every prop is optional because the controller's catch
 * branch renders this page with a smaller prop set.
 */
export default function Home({
  page_title,
  meta_description,
  description,
  sites,
  siteGroups,
  hero_banners,
  featured_vouchers,
  customer_stories,
  latest_news,
}: HomeProps) {
  const metaDescription = meta_description ?? description;

  return (
    <WebLayout>
      <Head title={page_title}>
        {metaDescription && <meta name="description" content={metaDescription} />}
        <meta property="og:title" content={page_title} />
        {metaDescription && <meta property="og:description" content={metaDescription} />}
        <meta property="og:type" content="website" />
      </Head>

      <HeroSearchSection sites={sites} banners={hero_banners} />
      <TrustStrip />

      <div className="container mx-auto max-w-7xl space-y-10 px-4 py-10 md:space-y-14 md:py-14">
        <FeaturedVouchersSection vouchers={featured_vouchers} />
        <NewsMasonrySection newsItems={latest_news} />
        <DestinationsSection sites={sites} locations={siteGroups} />
        <CustomerStoriesSection stories={customer_stories} />
      </div>

      <NewsletterSection />
    </WebLayout>
  );
}
